'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiChevronLeftOutline = function TiChevronLeftOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.7 33.3c-1.4 0-2.6-0.5-3.6-1.4l-11.8-11.9 11.8-11.9c1.9-1.9 5.2-1.9 7.1 0 0.9 1 1.5 2.2 1.5 3.6s-0.6 2.6-1.5 3.5l-4.8 4.8 4.8 4.8c0.9 0.9 1.5 2.2 1.5 3.5s-0.6 2.6-1.5 3.6c-0.9 0.9-2.2 1.4-3.5 1.4z m-10.7-13.3l9.5 9.5c0.6 0.6 1.7 0.6 2.3 0 0.4-0.3 0.5-0.7 0.5-1.2s-0.1-0.8-0.5-1.1l-7.1-7.2 7.1-7.2c0.4-0.3 0.5-0.7 0.5-1.1s-0.1-0.9-0.5-1.2c-0.6-0.6-1.7-0.6-2.3 0l-9.5 9.5z' })
        )
    );
};

exports.default = TiChevronLeftOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/chevron-left-outline.js
// module id = 3787
// module chunks = 0